// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/Clients/components/ClientsView.scss
// module id = 1245
// module chunks = 0